import { createApp } from 'vue'
import SchoolCreateForm from '../components/school-create/SchoolCreateForm.vue'

const el = document.getElementById('school-create-app')
if (el) {
  const props = JSON.parse(el.dataset.props ?? '{}')
  createApp(SchoolCreateForm, props).mount(el)
}
